export enum EUserRoles {
  user = 'user',
  superadmin = 'superadmin',
}
